module.exports = __webpack_public_path__ + "static/media/consulting_about_8.34a59c1e.webp";